import { HelmetDexteel } from "@dexteel/mesf-core";
import { RFactorPerStandReport } from "./components/RFactorPerStandReport";

export const RFactorPerStandPage = () => (
	<>
		<HelmetDexteel title="R-Factor per Stand" />
		<RFactorPerStandReport />
	</>
);
